window.getActiveExpansions = function(products) {
  const sets = new Set();
  products.forEach(product => {
    if (
      product.available &&
      product.metafields &&
      product.metafields.custom &&
      product.metafields.custom.set &&
      product.metafields.custom.set.trim() !== ''
    ) {
      sets.add(product.metafields.custom.set.trim());
    }
  });
  return Array.from(sets).sort();
};

// Función para actualizar automáticamente el filtro de expansiones
window.updateExpansionsFilter = function() {
  if (window.singlesProducts && window.getActiveExpansions) {
    const expansions = window.getActiveExpansions(window.singlesProducts);
    const expansionFilter = document.getElementById('search-expansion-filter');
    
    if (expansionFilter) {
      expansionFilter.innerHTML = '<option value="">Todas las expansiones</option>';
      expansions.forEach(exp => {
        const option = document.createElement('option');
        option.value = exp;
        option.textContent = exp;
        expansionFilter.appendChild(option);
      });
    }
  }
};

// Inicializar automáticamente cuando se carga la página
document.addEventListener('DOMContentLoaded', function() {
  // Pequeño delay para asegurar que todos los scripts estén cargados
  setTimeout(() => {
    window.updateExpansionsFilter();
  }, 100);
});

// También actualizar cuando se carga la ventana (por si acaso)
window.addEventListener('load', function() {
  window.updateExpansionsFilter();
}); 